import T from 'prop-types';
import React from 'react';
import { TextInput } from '@acast/decibel';
import Field from 'shared/components/field';

const DescriptionField = ({ value, onChange }) => (
  <Field label="Description" name="description">
    <TextInput value={value} onChange={event => onChange(event.target.value)} />
  </Field>
);

DescriptionField.propTypes = {
  onChange: T.func.isRequired,
  value: T.string,
};

export default DescriptionField;
